import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [displayText, setDisplayText] = useState('Press a Key');

  // Drum pad data
  const drumPads = [
    {
      key: 'Q',
      keyCode: 81,
      id: 'Heater-1',
      src: '/audio/Heater-1.mp3',
      name: 'Heater 1'
    },
    {
      key: 'W',
      keyCode: 87,
      id: 'Heater-2',
      src: '/audio/Heater-2.mp3',
      name: 'Heater 2'
    },
    {
      key: 'E',
      keyCode: 69,
      id: 'Heater-3',
      src: '/audio/Heater-3.mp3',
      name: 'Heater 3'
    },
    {
      key: 'A',
      keyCode: 65,
      id: 'Heater-4',
      src: '/audio/Heater-4_1.mp3',
      name: 'Heater 4'
    },
    {
      key: 'S',
      keyCode: 83,
      id: 'Clap',
      src: '/audio/Heater-6.mp3',
      name: 'Clap'
    },
    {
      key: 'D',
      keyCode: 68,
      id: 'Open-HH',
      src: '/audio/Dsc_Oh.mp3',
      name: 'Open HH'
    },
    {
      key: 'Z',
      keyCode: 90,
      id: 'Kick-n-Hat',
      src: '/audio/Kick_n_Hat.mp3',
      name: 'Kick n\' Hat'
    },
    {
      key: 'X',
      keyCode: 88,
      id: 'Kick',
      src: '/audio/RP4_KICK_1.mp3',
      name: 'Kick'
    },
    {
      key: 'C',
      keyCode: 67,
      id: 'Closed-HH',
      src: '/audio/Cev_H2.mp3',
      name: 'Closed HH'
    }
  ];

  // Function to play sound
  const playSound = (pad) => {
    const audio = document.getElementById(pad.key);
    audio.currentTime = 0;
    audio.play();
    setDisplayText(pad.name);
    
    // Add active class for visual feedback
    const drumPad = document.getElementById(pad.id);
    drumPad.classList.add('active');
    setTimeout(() => {
      drumPad.classList.remove('active');
    }, 100);
  };

  // Handle keyboard events
  const handleKeyPress = (event) => {
    const pad = drumPads.find(pad => 
      pad.key === event.key.toUpperCase()
    );
    if (pad) {
      playSound(pad);
    }
  };

  // Add event listener for keyboard
  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <div id="drum-machine" className="drum-machine">
      <div className="drum-container">
        <div className="drum-pads">
          {drumPads.map((pad) => (
            <div
              key={pad.id}
              id={pad.id}
              className="drum-pad"
              onClick={() => playSound(pad)}
            >
              {pad.key}
              <audio
                id={pad.key}
                className="clip"
                src={pad.src}
              ></audio>
            </div>
          ))}
        </div>
        
        <div id="display" className="display">
          {displayText}
        </div>
      </div>
    </div>
  );
}

export default App;